import { useEffect } from 'react';
import { useTabsStore } from '../store/tabsStore';
import { pruneLiveConnections } from '../utils/liveConnections';
import { pruneHttpEventStreams } from '../utils/httpEventStreams';
import { pruneGrpcTabState } from '../utils/grpcTabState';

/**
 * A live connection lasts as long as its TAB. Whenever the set of request tabs changes —
 * a tab closed, "close all", a workspace switch replacing them — whatever belonged to a
 * tab that is gone is closed. One subscription covers every way a tab can disappear.
 */
export function useLiveConnectionTabSync() {
  useEffect(() => {
    const sync = (tabs) => {
      const ids = (tabs || []).map((tab) => tab.id);
      pruneLiveConnections(ids);
      pruneHttpEventStreams(ids); // an event stream answering an HTTP request is a live connection too
      pruneGrpcTabState(ids); // a gRPC tab's loaded definition + picked method
    };
    sync(useTabsStore.getState().requestTabs);
    return useTabsStore.subscribe((state, previous) => {
      if (state.requestTabs !== previous.requestTabs) sync(state.requestTabs);
    });
  }, []);
}
